import React from 'react';

function Footer() {
  const lastUpdated = process.env.REACT_APP_LAST_UPDATED ||
    new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' });

  return (
    <footer className="footer">
      <p>
        Inspired by <a href="https://brittanychiang.com/" target="_blank" rel="noopener noreferrer">Brittany Chiang's Portfolio</a> and
        built using <a href="https://react.dev/" target="_blank" rel="noopener noreferrer">React</a> and
        <a href="https://code.visualstudio.com" target="_blank" rel="noopener noreferrer">Visual Studio Code</a>. Deployed with
        <a href="https://pages.github.com/" target="_blank" rel="noopener noreferrer">Github Pages</a>. Last updated {lastUpdated}.
      </p>
    </footer>
  );
}

export default Footer; 